import { DateType, Priority } from '../types/calendar';
import { IconName } from './icons';

// Shared UI helpers so different calendar views show consistent visual cues.

export const getDateTypeIcon = (dateType?: DateType): IconName | null => {
  switch (dateType) {
    case 'birthday':
      return 'birthday';
    case 'anniversary':
      return 'anniversary';
    case 'visit':
      return 'visit';
    case 'holiday':
      return 'holiday';
    case 'school':
      return 'school';
    case 'medical':
      return 'medical';
    case 'milestone':
      return 'milestone';
    default:
      return null;
  }
};

export const getPriorityBadgeColor = (priority?: Priority, isDarkMode?: boolean): string => {
  if (!priority || priority === 'medium') return '';

  if (isDarkMode) {
    switch (priority) {
      case 'low':
        return 'bg-blue-500/30 text-blue-300 border-blue-400/50';
      case 'high':
        return 'bg-orange-500/30 text-orange-300 border-orange-400/50';
      case 'critical':
        return 'bg-red-500/30 text-red-300 border-red-400/50';
      default:
        return '';
    }
  }

  switch (priority) {
    case 'low':
      return 'bg-blue-100 text-blue-700 border-blue-300';
    case 'high':
      return 'bg-orange-100 text-orange-700 border-orange-300';
    case 'critical':
      return 'bg-red-100 text-red-700 border-red-300';
    default:
      return '';
  }
};

export const getImportantDateBorder = (
  dateType: DateType | undefined,
  priority: Priority | undefined,
  isDarkMode?: boolean
): string => {
  const resolvedPriority = priority || 'medium';

  if (isDarkMode) {
    switch (dateType) {
      case 'birthday':
        return 'border-pink-300/40 shadow-pink-500/10';
      case 'anniversary':
        return 'border-purple-300/40 shadow-purple-500/10';
      case 'visit':
        return 'border-blue-300/40 shadow-blue-500/10';
      case 'holiday':
        return 'border-amber-300/40 shadow-amber-500/10';
      case 'school':
        return 'border-green-300/40 shadow-green-500/10';
      case 'medical':
        return 'border-red-300/40 shadow-red-500/10';
      case 'milestone':
        return 'border-amber-300/40 shadow-amber-500/10';
      default:
        return resolvedPriority === 'critical'
          ? 'border-red-300/40 shadow-red-500/10'
          : ''; // Use default peachy border color from style
    }
  }

  switch (dateType) {
    case 'birthday':
      return 'border-pink-300/60 shadow-pink-200/30';
    case 'anniversary':
      return 'border-purple-300/60 shadow-purple-200/30';
    case 'visit':
      return 'border-blue-300/60 shadow-blue-200/30';
    case 'holiday':
      return 'border-amber-300/60 shadow-amber-200/30';
    case 'school':
      return 'border-green-300/60 shadow-green-200/30';
    case 'medical':
      return 'border-red-300/60 shadow-red-200/30';
    case 'milestone':
      return 'border-amber-300/60 shadow-amber-200/30';
    default:
      return resolvedPriority === 'critical'
        ? 'border-red-300/60 shadow-red-200/30'
        : ''; // Use default peachy border color from style
  }
};

